import { tss } from "tss-react/mui";

export const useSharedStyles = tss.create(({ theme }) => ({
    overlineLight: {
        display: "inline-block",
        padding: `${theme.spacing(0.25)} ${theme.spacing(2.5)}`,
        borderRadius: "50px",
        backgroundColor: theme.palette.primary[50],
        border: `1px solid ${theme.palette.primary[200]}`,
        color: theme.palette.primary.main,
        fontWeight: 600,
        letterSpacing: "0.08em",
        fontSize: "0.75rem",
        textTransform: "uppercase" as const,
    },
    overlineDark: {
        display: "inline-block",
        padding: `${theme.spacing(0.25)} ${theme.spacing(2.5)}`,
        borderRadius: "50px",
        border: `1px solid ${theme.palette.primary[700]}`,
        backgroundColor: theme.palette.primary[900],
        color: theme.palette.primary.light,
        fontWeight: 600,
        letterSpacing: "0.08em",
        fontSize: "0.75rem",
        textTransform: "uppercase" as const,
    },
    eyebrow: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        color: theme.palette.primary.main,
        fontWeight: 600,
        letterSpacing: "0.15em",
        fontSize: "0.75rem",
        textTransform: "uppercase" as const,
        "&::before": {
            content: '""',
            display: "inline-block",
            width: "8px",
            height: "8px",
            backgroundColor: theme.palette.primary.main,
        },
    },
    sectionHighlight: {
        color: theme.palette.primary.main,
    },
    pageContainer: {
        width: "100%",
        maxWidth: "1640px",
        margin: "0 auto",
        padding: "80px 4%",
        [theme.breakpoints.down("sm")]: {
            padding: "48px 4%",
        },
    },
}));
